import { Td, Tr } from '@chakra-ui/table';
import React from 'react';
import { Row } from 'react-table';
import colors from '../../../../../../../styles/colors';

// eslint-disable-next-line @typescript-eslint/ban-types
interface TableDataRowProps<Data extends object> {
  row: Row<Data>;
  index: number;
  onRowClick?: (row: Data) => void;
  getRowBgColor?: (row: Data, index: number) => string | undefined;
  getCellBgColor?: (row: Data, columnId: string) => string | undefined;
  getCellProps?: (row: Data, columnId: string, index: number) => Record<string, unknown>;
}

// eslint-disable-next-line @typescript-eslint/ban-types
export function TableDataRow<Data extends object>({
  row,
  index,
  onRowClick,
  getRowBgColor,
  getCellBgColor,
  getCellProps,
}: TableDataRowProps<Data>): JSX.Element {
  const defaultBgColor = index % 2 === 0 ? colors.white : colors.gray_50;
  const bgColor = getRowBgColor ? getRowBgColor(row.original, index) ?? defaultBgColor : defaultBgColor;
  const { key: rowKey, ...rowProps } = row.getRowProps();

  return (
    <Tr
      key={rowKey}
      {...rowProps}
      cursor={onRowClick ? 'pointer' : 'default'}
      _hover={onRowClick ? { background: 'gray.100' } : undefined}
      onClick={() => onRowClick && onRowClick(row.original)}
      bg={bgColor}
      borderTop={`1px solid ${colors.gray[250]}`}
    >
      {row.cells.map((cell) => {
        const cellBgColor = getCellBgColor?.(row.original, cell.column.id);
        const customCellProps = getCellProps?.(row.original, cell.column.id, index) || {};

        if (customCellProps.display === 'none') return null;

        const { key: cellKey, ...cellProps } = cell.getCellProps();

        return (
          <Td
            key={cellKey}
            {...cellProps}
            isNumeric={cell.column.isNumeric}
            h="29px"
            px="12px"
            fontSize="13px"
            border={`1px solid ${colors.gray[250]}`}
            bg={cellBgColor}
            textAlign={cell.column.isNumeric ? 'right' : 'left'}
            {...customCellProps}
          >
            {cell.render('Cell')}
          </Td>
        );
      })}
    </Tr>
  );
}

TableDataRow.defaultProps = {
  onRowClick: undefined,
  getRowBgColor: undefined,
  getCellBgColor: undefined,
  getCellProps: undefined,
};
